
// import {extent as d3_extent} from 'd3-array'
import {select as d3_select} from 'd3-selection'
import {drag as d3_drag} from 'd3-drag'
import {scalePoint as d3_scalePoint} from 'd3-scale'
import {bisect as d3_bisect, range as d3_range} from 'd3-array'
// import drawGradientRect from '../utils/drawGradientRect'

let dragging
let BALL_TRANSITION = 700
let scale
function MultiDataPickerBehavior ($root,viz,config={}) {
  const mode = config.pickerMode //'select'/'buttons' //El bueno sera "slider"
  if(!viz.data) return

  let dataPicker = d3_select($root).selectAll('.data-picker').data((viz.data?.isMulti && config.multiDataMode==='evolution')?[mode]:[],(d)=>d)
  dataPicker.exit().remove()
  let dataPickerEnter= dataPicker.enter().append('div').attr('class','data-picker')
  dataPicker = dataPicker.merge(dataPickerEnter)
  let pages = viz.data.isMulti?viz.data.data.map((d,i)=>d.id):[0]

  if(mode==='select'){
    let select = dataPicker.select('select').merge(dataPickerEnter.append('select'))
    select
      .style('background-color', '#f6fafc')
      .style('border-color', '#cccccc')
      .style('border-radius', '5px')
      .style('border', '1px solid #deedf2')
      .style('color', '#000')
      .style('font-size', '16px')
      .style('height', '36px')
      .style('padding', '0 16px')
      .style('min-width', '130px')
    let options = select.selectAll('option').data(pages,(d)=>d)
    options.exit().remove()
    options.enter().append('option').attr('value',(d)=>d).text((d)=>d)
    select.on('change',(e)=>{
      viz.config = {...viz.config, currentPage: e.target.value}
    })
    
    // if(config.showPicker) {
    dataPicker.select('select').node().value = viz.config.currentPage
    // }
  } else if(mode==='buttons') {
    dataPicker.style('display','flex')
    let buttons = dataPicker.selectAll('.sheet-btn').data(pages,(d)=>d)
    let buttonsEnter = buttons.enter().append('div').attr('class','sheet-btn').style('position','relative')

      
    buttonsEnter.append('div').attr('class','shape rounded-rect')
      // .style('position','absolute')
      .style('height','40px')
      .style('border-radius','20px')
      .style('padding', '0 15px')
      .style('min-width', '130px')
      .style('display','flex')
      .style('align-items','center')
      .style('border','solid 1px #EC0000')
      .style('justify-content', 'center')
      .style('font-weight','bold')
      .style('margin','10px')
    
    buttonsEnter.append('div').attr('class','text')
      .text((d)=>d)
      .style('position','absolute')
      .style('top','50%')
      .style('left','50%')
      .style('transform','translate(-50%,-50%)')

    buttonsEnter.on('click',(e,d)=>{
      viz.config = {...viz.config, currentPage: d}
    })
    // if(config.showPicker) {
    dataPicker.selectAll('.sheet-btn').select('.shape')
      .style('background',(d)=>{
        return viz.config.currentPage === d ?'#EC0000':'#fff'
      })
    dataPicker.selectAll('.sheet-btn').select('.text')
      .style('color',(d)=>{
        return viz.config.currentPage === d ?'#fff':'#EC0000'
      })
        
    // }
    buttons.exit().remove()
  } else if (mode==='slider'){
    dataPicker.style('display','flex').style('align-items', 'center')

    let playBtn = dataPicker.selectAll('.play-btn').data([null])
    let playBtnEnter = playBtn.enter().append('svg').attr('class','play-btn')
    playBtnEnter.attr('width',36).attr('height', 36)
    playBtnEnter.append('g').append('circle')
      .attr('r',17)
      .attr('cx',17)
      .attr('cy',18)
      .attr('stroke','#deedf2')
      .attr('fill','#f6fafc')
      .style('cursor','pointer')
    playBtnEnter.append('g').attr('class','icon').append('path').attr('fill','#EC0000')
    
    playBtnEnter.on('click',()=>{
      onPlayClicked(viz)
      setPlayStyle(playBtn,viz.playing)
    })
        

    playBtn = dataPicker.select('.play-btn')
    setPlayStyle(playBtn,viz.playing && viz.config.currentPage!==pages[pages.length-1])
    
    let slider = dataPicker.selectAll('.slider').data([null])
    let sliderEnter = slider.enter().append('div').attr('class','slider').style('flex','1 1 auto').style('display','flex').style('align-items', 'center')
    sliderEnter.append('div').attr('class','value first-value').style('margin','15px')
    let holder = sliderEnter.append('div').attr('class','holder')
    holder.style('position','relative').style('flex','1 1 auto')
    holder.append('div').attr('class','bar rect')
      .style('position','absolute')
      .style('width','100%')
      .style('height','3px')
      .style('background-color','#eee')
      .style('transform','translate(0,-50%)')
    holder.append('div').attr('class','ghost rect')
      .style('position','absolute')
      .style('width','100%')
      .style('height','50px')
      .style('background-color','transparent')
      .style('opacity','0')
      .style('transform','translate(0,-50%)')
      .call(d3_drag()
        .on("start", (event)=>{
          let percent = 100*event.x/width
          percent = Math.max(Math.min(100,percent),0)
          d3_select(this).style("left",percent+'%')
          setPage(viz,invertedPos(scale,percent))
        })
      )
      
    holder.append('div').attr('class','ball circle')
      .style('width','14px')
      .style('height','14px')
      .style('border-radius','50%')
      .style('cursor','pointer')
      .style('background-color','#fff')
      .style('border','solid 1px #EC0000')
      .style('border-color','#EC0000')
      .style('position','absolute')
      .style('transform','translate(0,-50%)')
    sliderEnter.append('div').attr('class','value last-value').style('margin','15px')
    slider = slider.merge(sliderEnter)
    slider.select('.first-value').text(pages[0])
    slider.select('.last-value').text(pages[pages.length-1])

    let bar = dataPicker.select('.slider').select('.holder').select('.bar')
    let ball = slider.select('.holder').select('.ball')

    if(!scale) scale = d3_scalePoint()
    scale.domain(pages).range([0,100])
    let width = bar.node()?.parentNode.getBoundingClientRect().width || 1

    let vizTransDuration = window.fake_d3_duration || 1000
    let ballTransDuration = Math.min(BALL_TRANSITION,vizTransDuration*2)
    function dragstarted(){
      dragging = true
    }
    function dragged(event,d){
      let percent = 100*event.x/width
      percent = Math.max(Math.min(100,percent),0)
      d3_select(this).style("left",percent+'%')
      setPage(viz,invertedPos(scale,percent))
    }
    function dragended(event,t){
      dragging = false
      ball.transition().duration(ballTransDuration).style('left',scale(viz.config.currentPage)+'%')
    }
    let drag = d3_drag()
      .on("start", dragstarted)
      .on("drag", dragged)
      .on("end", dragended);
    holder.select('.ball').call(drag)
    
    if(!dragging) ball.transition().duration(ballTransDuration).style('left',scale(viz.config.currentPage)+'%')
    
  }
  viz.play = play.bind(viz)
  viz.pause = pause.bind(viz)
  viz.resetMultiData = resetMultiData.bind(viz)
}

function setPlayStyle(selection,playing){
  if(playing){
    selection.select('.icon').select('path').attr('transform','translate(11,10)').attr('d','M 0 0 L 4 0 L 4 16 L 0 16 L 0 0 M 8 0 L 12 0 L 12 16 L 8 16L 8 0')
  } else {
    selection.select('.icon').select('path').attr('transform','translate(11,9)').attr('d','M 0 0 L 16 9 L 0 18')
  }
}


function invertedPos(scale,pos) {
  var domain = scale.domain(); 
  var range = scale.range();
  var rangePoints = d3_range(range[0], range[1], scale.step())
  pos = pos + scale.step()/2
  rangePoints.push(range[1])
  var page = domain[d3_bisect(rangePoints, pos) -1];
  console.log("page",page)
  return page
}
function setPage(viz,page){
  if(viz.config.currentPage !== page){
    viz.config = {...viz.config, currentPage: page}
  }
}
function nextPage(viz,pages){
  let currentIdx = pages.indexOf(viz.config.currentPage)
  if(currentIdx + 1 >= pages.length) return false
  let nextPage = pages[currentIdx+1]
  setPage(viz,nextPage)
  return currentIdx + 2 < pages.length
}
import{timeout as d3_timeout} from 'd3-timer'

function loop(viz,pages,delay){
  if(nextPage(viz,pages)){
    // clearTimeout(viz._loopId)
    // viz._loopId = setTimeout(()=>{
    //   loop(viz,pages)
    // },1800)
    viz._loopTimer && viz._loopTimer.stop()
    viz._loopTimer = d3_timeout(()=>{
      loop(viz,pages,delay)
    },delay)
  } else {
    viz.playing = false
  }
}

function play (options){
  let {skipInitial} = options
  this.playing = true
  let delay = (window.fake_d3_duration || 1000)*2
  let pages = this.data.isMulti?this.data.data.map((d,i)=>d.id):[0]

  if(this.chart.ghostData) this.chart.ghostData = null;
  
  if(skipInitial){
    loop(this,pages,delay)
  } else {
    this._loopTimer = d3_timeout(()=>{
      loop(this,pages,delay)
    },delay)
  }
}
function pause(){
  this.playing = false
  // clearTimeout(this._loopId)
  this._loopTimer && this._loopTimer.stop()
}
function resetMultiData(){
  this.playing = false
  let pages = this.data.isMulti?this.data.data.map((d,i)=>d.id):[0]
  this.config = {...this.config, currentPage: pages[0]}
  // clearTimeout(this._loopId)
  this._loopTimer && this._loopTimer.stop()
}

function onPlayClicked(viz){
  if(viz.playing) viz.pause()
  else {
    let pages = viz.data.isMulti?viz.data.data.map((d,i)=>d.id):[0]
    if(pages.indexOf(viz.config.currentPage)===pages.length-1){
      viz.config = {...viz.config, currentPage: pages[0]}
      viz.play({skipInitial:false})
    } else {
      viz.play({skipInitial:true})
    }
  }
}
MultiDataPickerBehavior.defaultConfig = {
  index: 301,
  multiDataMode:{
    type: String,
    default: 'evolution',
    options: ['evolution','smallmultiples','fixed']
  },
  // showPicker: {
  //   type: Boolean,
  //   default: false,
  //   exposed: true,
  // },
  pickerMode: {
    type: String,
    default: 'slider',
    options: ['slider','buttons','select'],
    exposed: true,
  },
  // smallMultiples: {
  //   type: Boolean,
  //   default: true,
  //   exposed: true,
  // },
  smallMultiplesColumns:{
    type: [String,Number],
    default: 2,
    exposed: true
  }
 
}
MultiDataPickerBehavior.configName = 'MultiDataPickerBehavior'

export default MultiDataPickerBehavior
